import { actions } from "../../BasicReducer";
import api from "../ThesauriAPI";

export function reloadThesauri() {
  return (dispatch) =>
  api.get().then((response) => {
    dispatch(actions.set('thesauris', response));
  });
}